import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Smoking Cessation Forms
   */
  {
    // 1
    label: "What's your age?",
    field: 'scAge',
    type: 'info',
    answer: {
      type: 'number',
      name: 'age',
      min: 18,
      max: 100,
      placeholder: 'Please type here...'
    }
  },
  {
    // 2
    label: 'What gender do you identify as?',
    field: 'scGender',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        {
          key: 'female',
          value: 'Female',
          answer: {
            label: 'Are you pregnant, or breastfeeding?',
            type: 'radio',
            name: 'pregnant',
            options: [
              { key: 'yes', value: 'Yes' },
              { key: 'no', value: 'No' }
            ]
          }
        }
      ]
    }
  },
  {
    // 3
    label: 'What number of cigarettes do you smoke per day?',
    field: 'scCigarettes',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'fewerThan5', value: 'Fewer than 5' },
        { key: '6-10', value: '6-10' },
        { key: '11-20', value: '11-20' },
        { key: '21-30', value: '21-30' },
        { key: 'moreThan30', value: 'More than 30' }
      ]
    }
  },
  {
    // 4
    label: 'What number do you smoke on the weekend versus a weekday?',
    field: 'scWeekendCigs',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'fewerThan5', value: 'Fewer than 5' },
        { key: '6-10', value: '6-10' },
        { key: '11-20', value: '11-20' },
        { key: '21-30', value: '21-30' },
        { key: 'moreThan30', value: 'More than 30' }
      ]
    }
  },
  {
    // 5
    label:
      'When do you have your first cigarette of the day (how many minutes after you wake)?',
    field: 'firstCigarette',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'within30Mins', value: 'Always within 30 minutes of waking' },
        {
          key: 'sometimesWithin30Mins',
          value: 'Sometimes within 30 minutes of waking'
        },
        { key: 'varies', value: 'It varies depending on the day' }
      ]
    }
  },
  {
    // 6
    label: 'Type of smoking',
    field: 'typeSmoking',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'cigarettes', value: 'cigarettes' },
        { key: 'cigars', value: 'cigars' },
        { key: 'cigarellos', value: 'cigarellos' },
        { key: 'other', value: 'other (bidi, kretek)' }
      ]
    }
  },
  {
    // 7
    label: 'Age of onset of smoking (years)',
    field: 'ageSmoking',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'lessThan5', value: 'Less than 5 years' },
        { key: '6-10', value: '6 to 10 years' },
        { key: '11-15', value: '11 to 15 years' },
        { key: '16-20', value: '16 to 20 years' },
        { key: 'moreThan20', value: ' More than 20 years' }
      ]
    }
  },
  {
    // 8
    label: 'Maximum smoked per day (lifetime)',
    field: 'scMaxPerDay',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'fewerThan5', value: 'Fewer than 5' },
        { key: '6-10', value: '6-10' },
        { key: '11-20', value: '11-20' },
        { key: '21-30', value: '21-30' },
        { key: 'moreThan30', value: 'More than 30' }
      ]
    }
  },
  {
    // 9
    label: 'Have you ever tried quitting smoking in the past?',
    field: 'scQuitting',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No, this is my first attempt' },
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                label: 'How many attempts have you made to quit?',
                type: 'single_select',
                name: 'attemptsToQuit',
                options: [
                  { key: 'attempts1-2', value: '1-2 attempts' },
                  { key: 'attempts3-4', value: '3-4 attempts' },
                  { key: 'attempts5-6', value: '5-6 attempts' },
                  { key: 'attemptsMore6', value: 'More than 6 attempts' }
                ]
              },
              {
                label: 'When was your most recent attempt made?',
                type: 'single_select',
                name: 'recentAttempt',
                options: [
                  { key: 'recentLess3', value: 'Less than 3 months ago' },
                  { key: 'recent3-6', value: 'Between 3 and 6 months ago' },
                  { key: 'recent6-12', value: 'Between 6 and 12 months ago' },
                  { key: 'recentMore12', value: 'More than 12 months ago' }
                ]
              },
              {
                label:
                  'What was the duration of your most successful quit attempt (what is the longest you went without smoking)?',
                type: 'single_select',
                name: 'lengthOfLastAttempt',
                options: [
                  { key: 'lastIsNone', value: 'I could not quit at all' },
                  { key: 'lastLess1', value: 'Less than 1 month' },
                  { key: 'last1-3', value: '1 to 3 months' },
                  { key: 'last4-6', value: '4 to 6 months' },
                  { key: 'last6-12', value: '6 to 12 months' },
                  { key: 'lastMore12', value: 'More than 12 months' }
                ]
              },
              {
                label: 'How have you tried to quit before?',
                type: 'multi_select',
                name: 'how',
                options: [
                  {
                    key: 'buproprion',
                    value: 'Buproprion (Zyban or Wellbutrin)'
                  },
                  { key: 'varenicline', value: 'Varenicline (CHAMPIX)' },
                  {
                    key: 'nicotineReplacement',
                    value: 'Nicotine replacement (gum, patch, lozenges, etc..)'
                  },
                  { key: 'therapy', value: 'Therapy or support group' },
                  { key: 'coldTurkey', value: 'Cold Turkey' },
                  {
                    key: 'howOther',
                    value: 'Other',
                    answer: {
                      type: 'text',
                      name: 'howOtherDesc',
                      placeholder: 'Please describe'
                    }
                  }
                ]
              },
              {
                label: 'Why do you think you went back to smoking',
                type: 'multi_select',
                name: 'whyDidYouSmoke',
                options: [
                  {
                    key: 'wasntReady',
                    value: 'I tried to quit before I was ready'
                  },
                  {
                    key: 'otherInfluences',
                    value: 'Other people in the home or work also smoke'
                  },
                  {
                    key: 'stress',
                    value: 'I had a stressful situation come up in my life'
                  },
                  {
                    key: 'mood',
                    value: 'I could not control my mood without smoking'
                  },
                  {
                    key: 'whyOther',
                    value: 'Other',
                    answer: {
                      type: 'text',
                      name: 'whyOtherDesc',
                      placeholder: 'Please describe'
                    }
                  }
                ]
              }
            ]
          }
        }
      ]
    }
  },
  {
    // 10
    label: 'Can you describe your life style?',
    field: 'scLifeStyle',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'highStress', value: 'High stress environment' },
        { key: 'caffeine', value: 'Caffeine' },
        { key: 'alcohol', value: 'Alcohol' },
        { key: 'marijuana', value: 'Marijuana' },
        { key: 'livingWith', value: 'Living with smokers' },
        { key: 'workplaceSmoking', value: 'Workplace smoking' }
      ]
    }
  },
  {
    // 11
    label: 'Do you have any of these medical conditions?',
    field: 'scMedicalCond',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'moodDisorders', value: 'Mood disorders' },
        { key: 'heartDisease', value: 'Heart Disease' },
        { key: 'eatingDisorder', value: 'Eating Disorder' },
        { key: 'bipolarDisease', value: 'Bipolar Disease' },
        { key: 'schizophrenia', value: 'Schizophrenia' },
        {
          key: 'otherCond',
          value: 'Any other conditions',
          answer: {
            type: 'text',
            name: 'otherCondDesc',
            placeholder: 'Please type here...'
          }
        },
        {
          key: 'noneMedicalCond',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 12
    label: 'Do you take any medication?',
    field: 'scMedication',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'benzodiazepines', value: 'Benzodiazepines' },
        { key: 'antipsychotics', value: 'Antipsychotics' },
        { key: 'antidepressants', value: 'Antidepressants' },
        {
          key: 'otherPrescription',
          value:
            'Any other prescription medications (inhalers, patches, nasal sprays)'
        },
        { key: 'overCounter', value: 'Over the counter products' },
        {
          key: 'anyProducts',
          value: 'Any products to help with smoking cessation',
          answer: {
            type: 'text',
            name: 'otherCondDesc',
            placeholder: 'Please type here...'
          }
        },
        {
          key: 'noneMedication',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  }
];

export default questionsModels;
